import React from "react";
import {
  BANNER_ITEM_HEIGHT,
  BannerEditorImagePreviewProps,
} from "./BannerEditor.types";
import { Flex, Image } from "@chakra-ui/react";
import IconButton from "../../common/IconButton/IconButton";
import { EditIcon, TrashIcon } from "../../../icons";
import { useBooleanState } from "../../../hooks";

export const BannerEditorImagePreview: React.FC<
  BannerEditorImagePreviewProps
> = ({ picture, onEdit, onDelete, ...rest }) => {
  const isEditLoading = useBooleanState(false);

  const handleOnEdit = async () => {
    isEditLoading.true();
    await onEdit();
    isEditLoading.false();
  };

  return (
    <Flex
      w={"100%"}
      h={`${BANNER_ITEM_HEIGHT}px`}
      pos={"relative"}
      overflow={"hidden"}
      {...rest}
    >
      <Image objectFit={"cover"} src={picture.url} />
      <Flex position={"absolute"} right={5} top={3}>
        <IconButton
          onClick={handleOnEdit}
          isLoading={isEditLoading.state}
          p={0}
          w={"40px"}
          h={"40px"}
          mr={2}
          isCircle
        >
          <EditIcon />
        </IconButton>
        <IconButton onClick={onDelete} p={0} w={"40px"} h={"40px"} isCircle>
          <TrashIcon />
        </IconButton>
      </Flex>
    </Flex>
  );
};
